import { BareInput, InputStyling } from '../Input'
import { StyleFn } from '..'

export const Combobox: StyleFn = (theme) => {
  const { color, font, opacity, size } = theme
  const { root: inputStyles, _focused, _small, ...inputVariants } = InputStyling(theme)
  const { root: bareInputStyles } = BareInput(theme)
  const focusStyles = {
    ..._focused,
    '& $clearBtn': { display: 'inline-flex' },
  }
  return {
    root: {
      ...inputStyles,
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative',
      alignItems: 'center',
      height: 'auto',
      padding: size.spacing[4],
      paddingRight: `calc(${size.spacing[64]} + ${size.spacing[8]})`,
      '& $clearBtn': { display: 'none' },
      '&:hover $clearBtn': { display: 'inline-flex' },
      '&:focus': focusStyles,
      '&:focus-within': focusStyles,
    },
    popover: { '$popover&': { borderRadius: `0px 0px 3px 3px` } },
    menu: {
      backgroundColor: color.type === 'light' ? 'none' : 'rgba(255, 255, 255, 0.16)',
      maxHeight: '40vh',
      overflowY: 'auto',
      // increase specificity
      '$menu&': {
        padding: 0,
        minWidth: size.spacing[80],
        borderRadius: `0px 0px 3px 3px`,
      },
      '& li:last-child': {
        borderRadius: `0px 0px 3px 3px`,
      },
    },
    nomatch: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: size.spacing[8],
      padding: `${size.spacing[12]} ${size.spacing[16]}`,
      fontSize: font.size.small,
      color: color.getModalValues(color.text.tertiary),
    },
    groupLabel: {
      fontSize: font.size.xsmall,
      color: color.getModalValues(color.text.tertiary),
      pointerEvents: 'none',
    },
    groupItem: {
      paddingLeft: size.spacing[32],
    },
    input: {
      ...bareInputStyles,
      flexGrow: 1,
      minWidth: '1.875rem',
      textOverflow: 'ellipsis',
      padding: size.spacing[6],
      // increase specificity
      '$input&': { width: 0 },
    },
    chip: {
      margin: size.spacing[4],
    },
    adornment: {
      position: 'absolute',
      top: `calc(50% - ${size.spacing[16]})`,
      right: size.spacing[8],
    },
    clearBtn: { display: 'inline-flex' },
    checkbox: { '$checkbox&': { marginRight: 0 } },
    ...inputVariants,
    _small: {
      ..._small,
      height: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      '& $adornment': {
        top: `calc(50% - ${size.spacing[12]})`,
      },
    },
    _noclear: {
      paddingRight: size.spacing[40],
    },
    _disabled: {
      userSelect: 'none',
      pointerEvents: 'none',
      opacity: opacity.disabled,
      '& input:disabled': {
        opacity: 1,
      },
    },
  }
}
